import axios from 'axios';
import types from './mutations-types';

const actions = {
  async getCategories({ commit }, obj) {
    const resp = await axios.get(
      `${process.env.API_ROOT}/categories/${obj.companyId}`,
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
    commit(types.SET_COMPANY_CATEGORIES, resp.data.categories);
  },

  async getUsers({ commit }, obj) {
    const { data } = await axios.get(
      `${process.env.API_ROOT}/users/${obj.companyId}`,
      {
        headers: {
          'x-access-token': obj.token,
          'frontend-access-key': process.env.FRONTEND_ACCESS_KEY,
        },
        params: {
          page: obj.page,
          limit: obj.limit,
          filter: obj.filter,
          hideIndecxUsers: obj.hideIndecxUsers,
        },
      },
    );

    commit(types.SET_COMPANY_USERS, data);

    return data;
  },

  async getAllUsers({ commit }, obj) {
    const users = [{ value: 'none', text: 'Ninguém' }];

    const { data } = await axios.get(
      `${process.env.API_ROOT}/users/${obj.companyId}`,
      {
        headers: {
          'x-access-token': obj.token,
          'frontend-access-key': process.env.FRONTEND_ACCESS_KEY,
        },
        params: {
          ...obj.params,
        },
      },
    );

    data.users.map((el) => {
      if (el.treatmentsResponsible === true) {
        users.push({
          value: el._id,
          text: el.name,
        });
      }
    });
    commit(types.SET_COMPANY_ALL_USERS, users);
  },

  async registerUser({ commit }, obj) {
    await axios.post(
      `${process.env.API_ROOT}/user/${obj.companyId}`,
      {
        ...obj.user,
      },
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
  },

  async editUserInfo({ commit }, obj) {
    await axios.put(
      `${process.env.API_ROOT}/user/${obj.userId}`,
      {
        ...obj.data,
      },
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
  },

  async deleteUser({ commit }, obj) {
    await axios.delete(
      `${process.env.API_ROOT}/user/${obj.userId}/${obj.loggedUser}`,
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
  },

  async updateCategories({ commit }, obj) {
    const resp = await axios.put(
      `${process.env.API_ROOT}/categories/${obj.companyId}`,
      { ...obj.data },
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
    commit(types.SET_COMPANY_CATEGORIES, resp.data.categories);
  },

  async updateCompanyLogo({ commit }, obj) {
    const formData = new FormData();
    formData.append('file', obj.data.file);

    await axios.put(
      `${process.env.API_ROOT}/company/${obj.companyId}`,
      formData,
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
  },

  async updateprivacyPolicy({ commit }, obj) {
    if (obj.data.linkPrivacyPolicy) {
      await axios.put(
        `${process.env.API_ROOT}/company/${obj.companyId}`,
        { ...obj.data },
        {
          headers: {
            'x-access-token': obj.token,
          },
        },
      );
    } else {
      const formData = new FormData();
      formData.append('privacyPolicy', obj.data.file);
      await axios.put(
        `${process.env.API_ROOT}/company/${obj.companyId}`,
        formData,
        {
          headers: {
            'x-access-token': obj.token,
          },
        },
      );
    }
  },

  async updateMetricType({ commit }, obj) {
    await axios.put(
      `${process.env.API_ROOT}/company/${obj.companyId}`,
      { ...obj.params },
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/settings/actions.js